var $54b47fc030b7b21e$exports = {};
// Sélectionner les éléments
const $54b47fc030b7b21e$var$carouselImages = document.querySelectorAll(".carousel-img img");
const $54b47fc030b7b21e$var$dots = document.querySelectorAll(".dot");
let $54b47fc030b7b21e$var$currentIndex = 0;
// Fonction pour changer l'image et mettre à jour les dots
function $54b47fc030b7b21e$var$changeSlide(index) {
    // Mettre à jour l'image visible
    const offset = -index * 33.33; // Calculer le décalage en fonction de l'indice
    document.querySelector(".carousel-img").style.transform = `translateX(${offset}%)`;
    // Mettre à jour les dots
    $54b47fc030b7b21e$var$dots.forEach((dot)=>dot.classList.remove("active"));
    $54b47fc030b7b21e$var$dots[index].classList.add("active");
}
// Fonction pour faire défiler automatiquement les images
function $54b47fc030b7b21e$var$autoSlide() {
    $54b47fc030b7b21e$var$currentIndex = ($54b47fc030b7b21e$var$currentIndex + 1) % $54b47fc030b7b21e$var$carouselImages.length;
    $54b47fc030b7b21e$var$changeSlide($54b47fc030b7b21e$var$currentIndex);
}
// Changer d'image au clic sur un dot
$54b47fc030b7b21e$var$dots.forEach((dot)=>{
    dot.addEventListener("click", (e)=>{
        const index = parseInt(e.target.dataset.slide);
        $54b47fc030b7b21e$var$currentIndex = index;
        $54b47fc030b7b21e$var$changeSlide(index);
    });
});
// Sélection de tous les boutons avec la classe "bouton"
const $54b47fc030b7b21e$var$boutons = document.querySelectorAll(".bouton");
// Parcourir chaque bouton pour lui attacher un événement
$54b47fc030b7b21e$var$boutons.forEach((bouton)=>{
    bouton.addEventListener("click", ()=>{
        // Ajouter la classe 'clicked' au bouton cliqué
        bouton.classList.add("clicked");
        // Retirer la classe 'clicked' après 700 ms pour laisser l'animation se produire
        setTimeout(()=>{
            bouton.classList.remove("clicked");
        }, 700); // La durée ici doit correspondre à celle des transitions CSS
    });
});
// Démarrer le défilement automatique
setInterval($54b47fc030b7b21e$var$autoSlide, 3000); // Change d'image toutes les 3 secondes
// Initialisation : afficher la première image
$54b47fc030b7b21e$var$changeSlide($54b47fc030b7b21e$var$currentIndex);
//langue
// Sélection des éléments
const $54b47fc030b7b21e$var$menuToggle = document.getElementById("menu-toggle");
const $54b47fc030b7b21e$var$hiddenLinks = document.querySelector(".hidden-links");
const $54b47fc030b7b21e$var$icon = document.querySelector(".awesome-arrow");
// Gestion du clic
$54b47fc030b7b21e$var$menuToggle.addEventListener("click", ()=>{
    // Basculer la classe 'expanded' pour les liens cachés
    $54b47fc030b7b21e$var$hiddenLinks.classList.toggle("expanded");
    // Basculer la classe 'rotated' pour l'icône
    $54b47fc030b7b21e$var$icon.classList.toggle("rotated");
});


//# sourceMappingURL=index.dc0f41cf.js.map
